import { createAction, props } from '@ngrx/store';
import { EventItem } from '@shared';

export const loadUpcomingEvents = createAction('[Events] Load Upcoming Events', props<{
  page: number;
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());
export const loadUpcomingEventsSuccess = createAction(
  '[Events] Load Upcoming Events Success',
  props<{ events: EventItem[]; total: number; page: number; totalPages: number; limit: number; append: boolean; }>(),
);
export const loadUpcomingEventsFailure = createAction('[Events] Load Upcoming Events Failure', props<{
  error: string
}>());

export const loadMoreUpcomingEvents = createAction('[Events] Load More Upcoming Events', props<{
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());

export const loadPastEvents = createAction('[Events] Load Past Events', props<{
  page: number;
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());
export const loadPastEventsSuccess = createAction(
  '[Events] Load Past Events Success',
  props<{
    events: EventItem[];
    total: number;
    page: number;
    totalPages: number;
    limit: number;
    append: boolean;
    search?: string
  }>(),
);
export const loadPastEventsFailure = createAction('[Events] Load Past Events Failure', props<{ error: string }>());

export const loadMorePastEvents = createAction('[Events] Load More Past Events', props<{
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());

export const loadInPreparationEvents = createAction('[Events] Load In Preparation Events', props<{
  page: number;
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());
export const loadInPreparationEventsSuccess = createAction(
  '[Events] Load In Preparation Events Success',
  props<{ events: EventItem[]; total: number; page: number; totalPages: number; limit: number; append: boolean }>(),
);
export const loadInPreparationEventsFailure = createAction('[Events] Load In Preparation Events Failure', props<{
  error: string
}>());
export const loadMoreInPreparationEvents = createAction('[Events] Load More In Preparation Events', props<{
  search?: string;
  tagIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}>());
